/**
 * AIエラー処理の共通ユーティリティ
 * エラーを必ず文字列化して出す
 */

export function formatAiError(err: any) {
  const status = err?.status ?? err?.code ?? err?.response?.status ?? 'unknown';
  const message = err?.message ?? err?.response?.statusText ?? String(err);
  let json = '';
  try { 
    json = JSON.stringify(err); 
  } catch {
    // JSON化に失敗した場合は無視
  }
  
  return {
    status, 
    message, 
    json,
    string: `[status=${status}] ${message} ${json ? `| raw=${json}` : ''}`
  };
}

/**
 * AIエラーのログ出力と再スロー
 */
export function logAndRethrowAiError(err: any, context: string) {
  const f = formatAiError(err);
  console.error(`[AI] ${context} failed:`, f.string);
  throw err;
}
